<template>
  <div>
    <h2>正在退出登陆......</h2>
  </div>
</template>

<script>
export default {
  mounted() {
    for (let item in window.localStorage) {
      if (item.indexOf("ms-user-") > -1) {
        window.localStorage.removeItem(item)
      }
    }
    this.$store.state.NAV.drawer = false
    setTimeout(() => {
      this.$store.commit("showSnackbar", {
        type: "success",
        text: "退出登陆成功"
      });
      this.$router.push("/");
      this.$router.go(0);
    }, 300);
  }
};
</script>